module.exports = __webpack_public_path__ + "img/conny-f-stage3-blink.edff7748.png";